// Dark Mode Toggle for DAYSTAR Neobrutalism Design System

export default function themeToggle() {
    const STORAGE_KEY = 'daystar-theme';
    const toggleBtns = document.querySelectorAll('.gh-theme-toggle');

    function getPreferredTheme() {
        const savedTheme = localStorage.getItem(STORAGE_KEY);
        if (savedTheme) {
            return savedTheme;
        }
        return 'light';
    }

    function applyTheme(theme) {
        const isDark = theme === 'dark';
        document.documentElement.classList.toggle('dark', isDark);
        document.documentElement.setAttribute('data-theme', theme);

        toggleBtns.forEach(btn => {
            const textSpan = btn.querySelector('.gh-theme-toggle-text');
            if (textSpan) {
                textSpan.textContent = isDark ? 'TERANG' : 'GELAP';
            }
            btn.setAttribute('aria-label', isDark ? 'Beralih ke mode terang' : 'Beralih ke mode gelap');
        });
    }

    // Initialize
    const currentTheme = getPreferredTheme();
    applyTheme(currentTheme);

    // Click handler
    toggleBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const isDark = document.documentElement.classList.contains('dark');
            const nextTheme = isDark ? 'light' : 'dark';
            localStorage.setItem(STORAGE_KEY, nextTheme);
            applyTheme(nextTheme);
        });
    });
}

